import { useSelector } from 'react-redux'
import styled from 'astroturf/react'
import { Link } from '@calendly/ui/components/link'

import { buildCalendlyMarketingHref, CALENDLY_MARKETING_BASE_PATH } from 'utils/calendly_marketing_url'
import { BrandLogo } from 'components/layout/brand_logo'
import { useI18n } from 'locales'
import { isEmbeddedSelector } from 'selectors/embed'
import _Row from "booking_redesign_legal_footer-Row.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=Row";
import _LogoLink from "booking_redesign_legal_footer-LogoLink.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=LogoLink";
import _RightLinks from "booking_redesign_legal_footer-RightLinks.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=RightLinks";


const checkIfIframe = () => window.location !== window.parent.location

const Row = /*#__PURE__*/styled('div', null, {
  displayName: "Row",
  styles: _Row
})

const LogoLink = /*#__PURE__*/styled(Link, null, {
  displayName: "LogoLink",
  styles: _LogoLink
})

const RightLinks = /*#__PURE__*/styled('div', null, {
  displayName: "RightLinks",
  styles: _RightLinks
})

export const BookingRedesignLegalFooter = ({ className }) => {
  const { i18n } = useI18n()
  const embedFromStore = useSelector(isEmbeddedSelector)
  const isEmbedded = checkIfIframe() || embedFromStore
  const logoHref = buildCalendlyMarketingHref(CALENDLY_MARKETING_BASE_PATH)

  return (
    <Row className={className}>
      <LogoLink
        underline={false}
        standalone
        href={logoHref}
        target="_blank"
        rel="noopener noreferrer"
      >
        <BrandLogo size="16px" />
      </LogoLink>
      <RightLinks>
        <Link
          as="button"
          type="button"
          variant="subtle"
          standalone
          onClick={() => window.OneTrust?.ToggleInfoDisplay()}
        >
          {i18n.t('booking.terms_and_conditions.manage_cookies')}
        </Link>
        {!isEmbedded && (
          <Link
            variant="subtle"
            standalone
            href="https://calendly.com/legal/privacy-notice"
            target="_blank"
            rel="noopener noreferrer"
          >
            {i18n.t('booking.terms_and_conditions.privacy_policy')}
          </Link>
        )}
      </RightLinks>
    </Row>
  )
}
